module.exports = __webpack_public_path__ + "onprem_ico@2x.5689196f5a992b29b44140c0abe64eb3.png";